import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ALL_COMPANY_INFOS_QUERY } from "../../graphql/Company/CompanyInfos.graphql";

function CompanySelect({
  variables,
  value,
  label,
  size,
  name,
  icon,
  onChange,
  required,
  readOnly
}) {
  const { data, loading, error } = useQuery(ALL_COMPANY_INFOS_QUERY, {
    variables
  });

  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Control iconLeft size={size}>
        <Select.Container
          fullwidth
          color={
            error ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : "secondary"
          }
          size={size}
          state={loading || !data ? "loading" : undefined}
        >
          <Select
            disabled={readOnly}
            name={name}
            value={value}
            onChange={onChange}
          >
            <Select.Option value="">{label}</Select.Option>
            {!loading &&
              data &&
              data.Companys.map((company, i) => (
                <Select.Option
                  key={`company-select-${i}`}
                  value={company.CompanyId}
                >
                  {company.Name}
                </Select.Option>
              ))}
          </Select>
        </Select.Container>
        {icon && (
          <Icon align="left" size={size}>
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
      </Control>
    </Field>
  );
}

CompanySelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  variables: PropTypes.object,
  icon: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  readOnly: PropTypes.bool
};

CompanySelect.defaultProps = {
  variables: { where: { Active: true } }
};
export default CompanySelect;
